import * as Yup from 'yup';

const bookingFilterSchema = Yup.object({
    start_date: Yup.string()
        // .test('dob', 'Invalid start date', function (value) {
        //     return value && !isNaN(new Date(value).getTime());
        // })
        .nullable()
        .notRequired(),
    end_date: Yup.string()
        .nullable()
        // .test('dob', 'Invalid end date', function (value) {
        //     return value && !isNaN(new Date(value).getTime());
        // })
        .notRequired(),
    uuid_venue: Yup.array()
        .notRequired(),
    uuid_board: Yup.array()
        .notRequired(),
    uuid_user: Yup.array()
        .notRequired(),
    booking_status: Yup.array()
        .notRequired(),
    payment_status: Yup.array()
        .notRequired()
});

export default bookingFilterSchema;